import { render, staticRenderFns } from "./user-selection-detail.vue?vue&type=template&id=f43424c4&"
import script from "./user-selection-detail.vue?vue&type=script&lang=js&"
export * from "./user-selection-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports